import React from 'react';
import { PlayerButton } from './PlayerButton';

interface SkipForwardButtonProps {
  mediaElementId: string;
  onClick: () => void;
}

export const SkipForwardButton = React.memo(function SkipForwardButton({ mediaElementId, onClick }: SkipForwardButtonProps) {
  return (
    <PlayerButton
      className="kollab-player-skip-forward-btn"
      tooltip="Forward 5 seconds"
      aria-controls={mediaElementId}
      onClick={onClick}
    />
  );
});
